import Vue from 'vue';
import Router from 'vue-router';
import Wizard from '../components/wizard/Wizard.vue';
import Login from '../components/auth/Login.vue';
import Logout from '../components/auth/Logout.vue';
import Register from '../components/auth/Register.vue';

Vue.use(Router);

export default new Router({
    routes: [{
            path: '/',
            name: 'Wizard',
            component: Wizard,
        },

        // Authentication
        {
            path: '/auth/login',
            name: 'Login',
            component: Login,
        },

        {
            path: '/auth/register',
            name: 'Register',
            component: Register,
        },
    ],
});
